import React, { Component } from 'react';
import { Button } from '@beisen/chaos-ui';
import * as html from '../util/html';
require('./button.scss');

export default class BS_Button extends Component {
    constructor(props, context) {
        super(props, context);
        this.actions = props.actions;
        this.onTouchTap = this.onTouchTap.bind(this);
    }

    onTouchTap() {
        this.props.onTouchTap(this.props);
    }
    filterGroupButton(buttonId) {
        if (buttonId && buttonId.indexOf('dropdown') > -1) {
            return '';
        }
        return buttonId;
    }
    render() {
        let { cmp_data, btnIdx, buttonId, partId } = this.props;
        let iconName = cmp_data.icon;
        buttonId = this.filterGroupButton(buttonId);

        if (iconName) {
            iconName = iconName.replace(/sys-bgcolor-f(\d)/, ''); // 去除背景色
        }

        if (!iconName) {
            iconName = `sys-icon-m-tongyong${btnIdx + 1}`;
        }

        return (
            <Button
                buttonId={buttonId}
                partId={partId}
                className="BS-button"
                icon={{
                    iconName: iconName,
                    position: 'top',
                    style: { color: '#fff' }
                }}
                onTouchTap={this.onTouchTap}
                text={html.decode(cmp_data.title)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js